var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topNav"},_vm._l((_vm.showList),function(item){return _c('div',{key:item.type,staticClass:"btn_item pointer",on:{"click":function($event){return _vm.handleBtnClick(item.type)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }